export default {
    gadget_average_wireless_strength: "Average Wireless Strength",
    gadget_daily_device_vin_count: "Daily Device VIN Count",
    gadget_average_hdop: "Average Hdop",
    gadget_average_satellite_count: "Average Satellite Count",
    gadget_ignition_on_event_count: "Ignition On Event Count",
    gadget_late_event_count: "Late Event Count",
    gadget_max_min_odometer_difference: "Max Min Odometer Difference",
    gadget_power_disconnect_event_count: "Power Disconnect Event Count",
    gadget_low_battery_event_count: "Low Battery Event Count",
    gadget_low_total_event_count: "Total Event Count",
    gadget_low_maintenance_limit_exceeded_count: "Maintenance Limit Exceeded Count",
    gadget_maintenance_warnigs: "Maintenance Warnings",
}